import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormBox,
  title: 'Form Box',
  category: ComponentCategory.FormControls,
  droppable: true,
};
